<template lang="pug">
div
  section.hero.is-primary
    .hero-body
      .container
        h1.title Account
        p.subtitle Manage account details

  transition(name="long-fade")
    section.section(v-if="!loading")
      .container
        w-form(
          :complete="onComplete"
          :record="record"
          :mutation="mutation"
          :showSummaryError="true"
          :showSuccessMessage="true"
          :onValidate="validate"
          :cancel="onCancel")

          h2.title.is-4 Basic Info

          .columns
            .column
              .field
                label.label First Name
                .control
                  w-input(v-model="record.first_name" maxlength="30")
            .column
              .field
                label.label Last Name
                .control
                  w-input(v-model="record.last_name" maxlength="30")

          h2.title.is-4 Notification Settings

          .field
            label.checkbox
              input(type="checkbox" v-model="record.notify_new_posting")
              b  New Needs
              |  - I want to help others in need by getting notified when a new need is posted
</template>

<script>
import EDIT_USER from '@/graphql/users/edit.gql'
import UPDATE_USER from '@/graphql/users/update.gql'

export default {
  data () {
    return {
      loading: true,
      user: null,
      record: null
    }
  },

  computed: {
    mutation () {
      return UPDATE_USER
    }
  },

  apollo: {
    user: {
      query: EDIT_USER,
      fetchPolicy: 'no-cache',
      skip () {
        return !this.$auth.userId
      },
      variables () {
        return {
          id: this.$auth.userId
        }
      },
      update (data) {
        const user = data.users_by_pk
        if (user) {
          this.record = {
            id: user.id,
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            notify_new_posting: user.notify_new_posting || false
          }
          this.loading = false
        }
        return user
      }
    }
  },

  methods: {
    onComplete (data) {
    },
    onCancel () {
      this.$router.go(-1)
    },
    validate () {
      if (this.record.notify_new_posting && !this.record.first_name) {
        return 'Please provide your first name when signing up for email notifications'
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
